import type { Entry, RegistrationContext } from './types';

export const REGISTRATION_CONTEXT_KEY = 'aye.registration';

const ENTRIES: readonly Entry[] = [
  'direct',
  'checkoutRequired',
  'checkoutOptional',
  'onglaye'
];

export function loadRegistrationContext(): RegistrationContext | null {
  try {
    const raw = window.sessionStorage.getItem(REGISTRATION_CONTEXT_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object') return null;
    if (!ENTRIES.includes(parsed.entry)) return null;
    return parsed as RegistrationContext;
  } catch {
    return null;
  }
}

export function saveRegistrationContext(ctx: RegistrationContext): void {
  try {
    window.sessionStorage.setItem(
      REGISTRATION_CONTEXT_KEY,
      JSON.stringify(ctx)
    );
  } catch {
    // Storage unavailable: the flow continues in memory only.
  }
}

export function clearRegistrationContext(): void {
  try {
    window.sessionStorage.removeItem(REGISTRATION_CONTEXT_KEY);
  } catch {
    // Nothing to clear.
  }
}
